import { REDUX_STATUS } from '@gymaholic/packages'
import { getObjectUtil } from 'packages/src'

function isLoadingReduxSelector (path) {
  return state => getObjectUtil(state, `${path}.status`) === REDUX_STATUS.LOADING
}

export default isLoadingReduxSelector
